import { getFileNameFromUrl, isCadFileName } from '@/bundles/Upload/helpers';
import { IAttachment } from '@/bundles/Attachment/types';

const ICONS_BY_EXTENSION: Readonly<Record<string, string>> = Object.freeze({
  pdf: 'mdi-file-pdf-box',
  png: 'mdi-file-image',
  jpg: 'mdi-file-image',
  jpeg: 'mdi-file-image',
  gif: 'mdi-file-image',
  webp: 'mdi-file-image',
  heic: 'mdi-file-image',
  svg: 'mdi-file-image',
  xls: 'mdi-file-excel',
  xlsx: 'mdi-file-excel',
  csv: 'mdi-file-excel',
  doc: 'mdi-file-word',
  docx: 'mdi-file-word',
  ppt: 'mdi-file-powerpoint',
  pptx: 'mdi-file-powerpoint',
  zip: 'mdi-folder-zip',
});

// Stored urls are uuid keys, so the uploaded file's name is the only type signal;
// an attachment without one was added as a link.
export const getAttachmentIcon = (attachment: Pick<IAttachment, 'original' | 'url'>): string => {
  const fileName = attachment.original?.name;
  if (!fileName) {
    return 'mdi-link-variant';
  }

  if (isCadFileName(fileName)) {
    return 'mdi-vector-square';
  }

  const extension = getFileNameFromUrl(fileName).split('.').pop()?.toLowerCase() ?? '';

  return ICONS_BY_EXTENSION[extension] ?? 'mdi-file-document-outline';
};
